import { Box, Divider, Flex, HStack, Image, Link as ChakraLink, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  redirectBaseUrl?: string;
}

const SOCIALS = [
  { icon: "/FB.svg", url: "https://www.facebook.com/LubBezposrednioPL/" },
  { icon: "/Tiktok_Black _Icon.svg", url: "https://www.tiktok.com/@lubbezposrednio.pl" },
  { icon: "/TWIT.svg", url: "https://twitter.com/LubBezposrednio" },
  { icon: "/YouTube_full-color_icon_(2017).svg", url: "https://www.youtube.com/@LubBezposrednioPL" }
];

type FLink = { label: string; to?: string; href?: string };

const FooterLink: React.FC<FLink> = ({ label, to, href }) => {
  const sx = {
    fontSize: "14px",
    color: "rgba(255,255,255,0.72)",
    _hover: { color: "white", textDecoration: "none" }
  };
  return to ? (
    <ChakraLink as={Link} to={to} {...sx}>
      {label}
    </ChakraLink>
  ) : (
    <ChakraLink href={href} isExternal {...sx}>
      {label}
    </ChakraLink>
  );
};

const FooterCol: React.FC<{ title: string; links: FLink[] }> = ({ title, links }) => (
  <VStack align="flex-start" spacing="12px">
    <Text fontSize="13px" fontWeight="700" textTransform="uppercase" letterSpacing="0.06em" color="rgba(255,255,255,0.5)">
      {title}
    </Text>
    {links.map(l => (
      <FooterLink key={l.label} {...l} />
    ))}
  </VStack>
);

export const Footer: React.FC<FooterProps> = ({ redirectBaseUrl }) => {
  const base = redirectBaseUrl ?? "";
  const backend = process.env.REACT_APP_BACKEND_URL;
  const year = new Date().getFullYear();

  return (
    <Box as="footer" w="100%" bg="primary" color="white" mt="auto">
      <Box maxW="1240px" mx="auto" px={{ base: "24px", md: "40px", xl: "56px" }} py={{ base: "44px", md: "60px" }}>
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: "34px", lg: "28px" }}>
          <VStack align="flex-start" spacing="18px" maxW="320px">
            <ChakraLink as={Link} to={base || "/"}>
              <Image src="/LBP_Logo_White.svg" alt="lubbezpośrednio.pl" h="34px" />
            </ChakraLink>
            <Text fontSize="14px" color="rgba(255,255,255,0.72)" lineHeight="22px">
              Darmowa platforma do wiarygodnych głosowań online, zabezpieczonych kryptografią i technologią blockchain.
            </Text>
            <HStack spacing="18px" pt="2px">
              {SOCIALS.map(s => (
                <ChakraLink key={s.url} href={s.url} isExternal aria-label="social">
                  <Image src={s.icon} alt="" h="20px" filter="brightness(0) invert(1)" opacity={0.75} transition="opacity 0.15s" _hover={{ opacity: 1 }} />
                </ChakraLink>
              ))}
            </HStack>
          </VStack>

          <FooterCol
            title="Platforma"
            links={[
              { label: "O platformie", to: base + "/o-nas" },
              { label: "Jak stworzyć głosowanie", to: base + "/jak-stworzyc-glosowanie" },
              { label: "Jak zagłosować", to: base + "/jak-zaglosowac" },
              { label: "Aktywne głosowania", to: base + "/aktywne-glosowania" },
              { label: "FAQ", to: base + "/faq" }
            ]}
          />

          <FooterCol
            title="Dokumenty"
            links={[
              { label: "Regulamin", to: base + "/regulamin" },
              { label: "Polityka prywatności", to: base + "/polityka-prywatnosci" },
              { label: "Deklaracja dostępności", to: base + "/deklaracja-dostepnosci" },
              { label: "Bezpieczeństwo dzieci", to: base + "/standardy-bezpieczenstwa-dzieci" }
            ]}
          />

          <FooterCol
            title="Instytut"
            links={[
              { label: "O kampanii", href: "https://instytut.lubbezposrednio.pl/nasza-wiarygnodnosc/o-kampanii/" },
              { label: "Organizator kampanii", href: "https://instytut.lubbezposrednio.pl/nasza-wiarygnodnosc/organizator-kampanii/" },
              { label: "Rejestr umów", href: "https://instytut.lubbezposrednio.pl/nasza-wiarygnodnosc/rejestr-umow/" },
              { label: "Finansowanie", href: "https://instytut.lubbezposrednio.pl/nasza-wiarygnodnosc/finansowanie/" },
              { label: "LubBezpośrednio.pl", href: "https://instytut.lubbezposrednio.pl/" }
            ]}
          />
        </SimpleGrid>

        <Divider my="32px" borderColor="rgba(255,255,255,0.15)" />

        <Flex direction={{ base: "column", md: "row" }} justify="space-between" align={{ md: "center" }} gap="14px">
          <Text fontSize="12px" color="rgba(255,255,255,0.5)" maxW="780px" lineHeight="18px">
            Zadanie Instytutu Demokracji Bezpośredniej jest dofinansowane z budżetu państwa ze środków otrzymanych od
            Kancelarii Prezesa Rady Ministrów. Wartość dofinansowania: 4 284 900 zł (100% wartości zadania publicznego).
          </Text>
          <Text fontSize="12px" color="rgba(255,255,255,0.55)" whiteSpace="nowrap">
            © {year} lubbezposrednio.pl
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};
